/**
 * @generated SignedSource<<29bd8913bcd5970f4c384681348d6184>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AppClipActionTitle = "OPEN" | "VIEW" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AppClipDefaultCard_appConfig$data = {
  readonly appClipActionText: AppClipActionTitle;
  readonly appClipHeaderImageUrl: string | null;
  readonly appClipSubtitle: string;
  readonly id: string;
  readonly " $fragmentType": "AppClipDefaultCard_appConfig";
};
export type AppClipDefaultCard_appConfig$key = {
  readonly " $data"?: AppClipDefaultCard_appConfig$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppClipDefaultCard_appConfig">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppClipDefaultCard_appConfig",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appClipHeaderImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appClipSubtitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appClipActionText",
      "storageKey": null
    }
  ],
  "type": "BrandAppConfigType",
  "abstractKey": null
};

(node as any).hash = "56ccc39a05ff4bbee1402e9aecece60f";

export default node;
